module.exports = __webpack_public_path__ + "img/ok_color.cd4b2936.svg";